import { Box } from "@mui/material";
import { colors, typography, spacing } from "../../../../assets/styles/tokens";

export type AnalyticsMobileView = "highLevel" | "breakdown";

interface AnalyticsMobileTabsProps {
  view: AnalyticsMobileView;
  onChange: (view: AnalyticsMobileView) => void;
  disabled?: boolean;
}

const OPTIONS: { value: AnalyticsMobileView; label: string }[] = [
  { value: "highLevel", label: "High Level" },
  { value: "breakdown", label: "Breakdown" },
];

// Same pill-segmented-control look as the desktop LeadsStatusTabs (light
// gray track, selected segment gets a white pill + soft shadow) — reused
// here as a plain two-way toggle since Analytics' High Level/Breakdown
// split has no per-tab data to drive (unlike the status tabs' counts).
export default function AnalyticsMobileTabs({ view, onChange, disabled }: AnalyticsMobileTabsProps) {
  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: colors.GrayLightMode[100].$value,
        borderRadius: spacing.Radius.lg.$value,
        p: spacing.Spacing.xxs.$value,
        mt: spacing.Spacing.lg.$value,
        gap: spacing.Spacing.xs.$value,
      }}
    >
      {OPTIONS.map((option) => {
        const selected = option.value === view;
        return (
          <Box
            key={option.value}
            onClick={disabled ? undefined : () => onChange(option.value)}
            sx={{
              flex: 1,
              textAlign: "center",
              py: spacing.Spacing.xs.$value,
              borderRadius: spacing.Radius.md.$value,
              cursor: disabled ? "default" : "pointer",
              bgcolor: selected ? colors.Base.White.$value : "transparent",
              boxShadow: selected ? "0 1px 2px rgba(0,0,0,0.08)" : "none",
              fontFamily: typography.Font_Family.$value,
              fontWeight:
                selected && !disabled
                  ? typography.Font_weight.Bold.$value
                  : typography.Font_weight.Medium.$value,
              fontSize: typography.Size.Text.xs.$value,
              lineHeight: typography.Line_height.text.xs.$value,
              letterSpacing: "0%",
              color:
                selected && !disabled
                  ? colors.GrayLightMode[900].$value
                  : colors.GrayLightMode[500].$value,
            }}
          >
            {option.label}
          </Box>
        );
      })}
    </Box>
  );
}
